import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import RepeatIcon from 'mdi-react/RepeatIcon';
import { partial } from '../../../../util/translation/translation';

// On the event page of one date of a series: which series it belongs to,
// and that changes made here only affect this date
const OccurrenceBanner = ({ event }) => {
  const p = partial('EventSeries');
  return (
    <div className="series-banner">
      <RepeatIcon size={20} className="series-banner__icon" />
      <div className="series-banner__text">
        <span>
          {p('bannerPartOf', { title: event.series?.title || p('aSeries') })}
        </span>
        {event.cancelledAt && (
          <span className="series-banner__cancelled">
            {p('bannerCancelled')}
            {event.cancelMessage ? ` "${event.cancelMessage}"` : ''}
          </span>
        )}
      </div>
      <Link
        to={`/events/series/${event.seriesId}`}
        className="btn btn-outline-primary btn-sm mb-0"
      >
        {p('openSeries')}
      </Link>
    </div>
  );
};

OccurrenceBanner.propTypes = {
  event: PropTypes.shape({
    seriesId: PropTypes.string,
    series: PropTypes.shape({ title: PropTypes.string }),
    cancelledAt: PropTypes.string,
    cancelMessage: PropTypes.string,
  }).isRequired,
};

export default OccurrenceBanner;
